import type React from 'react';

import { Close } from '@shared/assets';
import { IconButton } from '@shared/ui/buttons';

import * as st from './styles.module.scss';

type Props = {
	left?: JSX.Element;
	right?: JSX.Element;
	title?: string;
	onClose?: () => void;
};

export const LargeHeaderMobile: React.FC<Props> = ({ left, right, title, onClose }) => {
	return (
		<div className={st.header}>
			<div className={st.header__left}>
				{left ?? (
					<IconButton variant="dark" onClick={onClose}>
						<Close />
					</IconButton>
				)}
			</div>
			<div className={st.header__title}>
				<>{title}</>
			</div>
			<div className={st.header__right}>
				<>{right}</>
			</div>
		</div>
	);
};
